import React, { Component } from 'react';
import ProjectService from "../service/projectService";
import NavigationBar from "../components/navigationBar";
import AuthTokenService from '../service/authTokenService';
import "../design/loginform.css";

import {
    Link
} from "react-router-dom";

export default class Projects extends Component {

    constructor(props) {
        super(props);
        this.projectService = new ProjectService();
        this.authTokenService = new AuthTokenService();
        this.state = {
            projects: [],
            Title: ""
        }
        this.handleChange = this.handleChange.bind(this);
    }
    async getProjects() {
        let result = await this.projectService.retrieveProjects();
        if (result.status === 401) {
            this.props.history.push("/Login");
        }
        else {
            this.setState({
                projects: result
            })
        }
    }
    componentDidMount() {
        document.title = "Project Overview";
        this.getProjects();
    }

    handleChange({ target }) {
        this.setState({
            [target.name]: target.value
        });
    }

    showOverlay() {
        document.getElementById("overlay").style.display = "block";
    }

    hideOverlay() {
        document.getElementById("overlay").style.display = "none";
    }

    async createProject(event) {
        event.preventDefault();

        let results = await this.projectService.createNewProject(this.state.Title);
        if (results.status === 401) {
            this.props.history.push("/Login");
        }
        else {
            this.hideOverlay();
            this.getProjects();
        }
    }


    render() {
        const projects = this.state.projects;
        if (!projects) return null;

        console.log(projects)

        return (
            <div className="body">
                <div id="overlay">
                    <div id='LoginDiv' className='content'>
                        <button onClick={this.hideOverlay}>Back</button><br />
                        <h1>Create Project</h1>
                        <form action="#" onSubmit={(event) => { this.createProject(event) }}>
                            <label className="labelLoginForm" htmlFor="Title"><b>Project Name:</b></label><br />
                            <input className="loginInputLabel" type="text" placeholder="Project Name" name="Title" value={this.state.Title} onChange={this.handleChange} required /><br />
                            <button className="buttonLoginSubmit" type="submit">Create Project</button>
                        </form>
                    </div>
                </div>
                <NavigationBar {...this.props} />
                <main>
                    <center><h1>Projects</h1></center>
                    <button onClick={this.showOverlay}>Create New</button>
                    <div className='projects-overview-container'>
                    {this.state.projects.map((project) => (
                        <div className="projects-overview-info" key={project.projectUUID}>
                            <div>
                                <Link to={"/Project/" + project.projectUUID}>
                                <p className="card-title">
                                    {project.projectName}
                                </p>
                                </Link>
                            </div>
                        </div>
                    ))}
                    </div>                    
                </main>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/sites/projects.js